
import { KeyboardEvent } from "react";
import { base_url } from "../../../constants";
import { ventana } from "../../../utilities/Alertas";
import icon_buscar from '../../../assets/images/svg/search_2.svg';

export default function Buscar(){    
    const savePalabra = (e: KeyboardEvent<HTMLInputElement>) =>{ 
        if(e.key==='Enter') return buscar()
        localStorage.setItem('palabra',(e.currentTarget.value))
     }
    const buscar = () => {
        const input_busqueda = (localStorage.getItem("palabra") !== null)? localStorage.getItem("palabra")!:"";
        if(input_busqueda !== '') return window.location.replace(`/${base_url}/busqueda?q=${localStorage.getItem('palabra')}`)
        ventana('Búsqueda', 'Debe especificar un criterio para realizar la búsqueda de información', 'info')        
    }
    
    return(        
        <div className="col-12 col-lg-4 order-1 order-lg-2 d-flex align-items-center">            
            <div className="col-12">
                <div className="col-12 d-flex align-items-center search_container">
                <form>
                    <div className="input-group search_input">
                        <input onKeyUp={ (e) => savePalabra(e)} type="text" id="palabra" autoComplete="new-password" defaultValue={localStorage.getItem('palabra')!} name="palabra" className="form-control palabra" placeholder="¿Qué deseas buscar?" aria-label="¿Qué deseas buscar?" aria-describedby="button-addon2" maxLength={50}/>
                        <button onClick={ () => buscar()} className="btn btn-outline-secondary d-flex align-items-center" type="button" id="button-addon2">
                            <img src={icon_buscar} alt="search icono" height="30px" className="me-2"/>Buscar
                        </button>
                    </div>
                </form>
                </div>
            </div>
        </div> 
    )
}